import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import DevaranaList from './DevaranaList';
import DevaranaUpdate from './DevaranaUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsDevaranaStore'
)
@observer
class DevaranaPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsDevaranaStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsDevaranaStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsDevaranaStore.setshowModal(false);
    }

    render() {
        const {
            showModal,
            modalTitle
        } = this.props.CmsDevaranaStore;

        return (
            <MainContainer title='Devarana Wellness Management' menukey='devaranas'>
                <Modal
                    title={modalTitle}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <DevaranaUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <DevaranaList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default DevaranaPage